module.exports = __webpack_public_path__ + "img/stvrt-block-2.fd51220e.jpg";